module.exports = __webpack_public_path__ + "img/error_fichaje_icon.402c6909.svg";